import React from "react"
import { Link } from "gatsby"

import Logo from "../logo/logo"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "../../utils/fontawesome"

import headerStyles from "./header.module.scss"

const Header = () => {
  return (
    <header className={headerStyles.header}>
      <div className={headerStyles.navContent}>
        <Logo />
        <nav>
          <ul>
            <li>
              <Link className={headerStyles.navItem} to="/">
                Home
              </Link>
            </li>
            <li>
              <Link className={headerStyles.navItem} to="/projects">
                Projects
              </Link>
            </li>
            <li>
              <a
                href="https://blog.alkhalaf.dev"
                className={headerStyles.navItem}
              >
                Blog
              </a>
            </li>
            <li>
              <a href="mailto:yazeedfady@gmail.com">
                <FontAwesomeIcon
                  icon={`envelope`}
                  className={headerStyles.emailIcon}
                />
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  )
}

export default Header
